import { memo } from "react";
import { Link, Tooltip } from "@mui/material";

import { useNotificationContext } from "@4uhub/lib4uhub";
import { useTranslation } from "react-i18next";
import { buildEvaluationSurveyLink } from "./utils";

const translationPath = "page.evaluation.logs.";

interface IEvaluationIdProps {
  data: string;
  portalDomain?: string | null;
}
const Evaluationid: React.FC<IEvaluationIdProps> = ({ data, portalDomain }) => {
  const { setMessage } = useNotificationContext();
  const { t } = useTranslation();
  const surveyLink = buildEvaluationSurveyLink(portalDomain, data);

  const onClickHandler = () => {
    navigator.clipboard.writeText(surveyLink);
    setMessage({
      message: t(translationPath + "copied_successfully"),
      type: "success",
    });
  };

  return (
    <Tooltip title={surveyLink || data}>
      <Link
        component="button"
        variant="body2"
        onClick={onClickHandler}
        textOverflow={"ellipsis"}
        overflow={`hidden`}
      >
        {data}
      </Link>
    </Tooltip>
  );
};

export default memo(Evaluationid);
